<template>
<!--
	the way this is designed to be used is that you apply a class/style attribute from the outside
	and then all styling is done on this root element (see homepage for example use)

	placeholder text is passed as a slot, so you can style it or something with HTML
	the flex layout means that you can set padding/width/etc, and everything else should just handle itself

	there are a couple wonky things:
	1. if you're using an icon, you have to also set a height, otherwise the icon won't be the correct height

	2. the placeholder text can overlap the icon, since the PH text is an absolute element
	(this is fixable, just involves adding some HTML/CSS mess, and if we don't need it for the time being, would be nice to leave it)
-->
	<div class="bespoke-input">
		<div class="bespoke-input-inner">
			<div
				v-show="!value && !focused"
				class="bespoke-input-inner__placeholder"
				@click="$refs.input.focus()"
			>
				<slot/>
			</div>
			<input
				type="text"
				class="bespoke-input-inner__field"
				ref="input"

				:value="value"
				@input="$emit('input', $event.target.value)"

				@focus="focused = true; $emit('focus', $event)"
				@blur="focused = false; $emit('blur', $event)"
			/>
			<img 
				v-if="icon"
				:src="icon"
				class="bespoke-input-inner__icon"
				:class="{'bespoke-input-inner__icon--has-action': iconClick}"
				@click="iconClick && iconClick()"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: String,
		icon: String,
		iconClick: Function
	},
	data: () => ({
		focused: false
	})
}
</script>

<style lang="scss" scoped>
.bespoke-input {
	&-inner {
		display: flex;
		align-items: center;
		position: relative;
		overflow: hidden;
		height: 100%;

		&__placeholder {
			position: absolute;
			left: 0;
			pointer-events: none;
		}

		&__field {
			padding: 0;
			border: none;
			border-radius: 0;
			background: none;
			color: currentColor;
			font-size: inherit;
			min-width: 0;
			height: 100%;
			flex-grow: 1;
		}

		&__icon {
			margin-left: 0.65em;
			height: 100%;

			&--has-action {
				cursor: pointer;
				opacity: 0.7;
				transition: opacity 0.25s;

				&:hover {
					opacity: 1;
				}
			}
		}
	}
}
</style>